/**
 * Lista de registros DS para publicar no pai (registro.br, RIR).
 *
 * O PowerDNS devolve o DS da mesma chave em mais de um digest (SHA-256 e
 * SHA-384). Sem rótulo, isso parece "duas chaves", e o operador tenta publicar
 * os dois — mas o SHA-384 é grande e alguns registradores (o registro.br entre
 * eles) não aceitam. Aqui cada DS vem rotulado pelo digest, e a nota deixa claro
 * que basta um — o SHA-256, o universal.
 */

const DIGESTS: Record<string, string> = {
  '1': 'SHA-1',
  '2': 'SHA-256',
  '3': 'GOST',
  '4': 'SHA-384',
};

export function ListaDs({ ds }: { ds: string[] }) {
  if (ds.length === 0) {
    return (
      <div className="rounded-chip bg-escuro px-3 py-2.5 font-mono text-[11.5px] text-texto-mudo">
        DS indisponível
      </div>
    );
  }

  return (
    <div>
      <div className="rounded-chip bg-escuro px-3 py-2.5 font-mono text-[11.5px] leading-relaxed text-white">
        {ds.map((d, i) => {
          const nome = DIGESTS[d.trim().split(/\s+/)[2] ?? ''];
          return (
            <div key={i} className="break-all py-0.5">
              {nome && (
                <span className="mr-1.5 rounded bg-white/15 px-1 py-px font-sans text-[10px] font-bold tracking-wide">
                  {nome}
                </span>
              )}
              {d}
            </div>
          );
        })}
      </div>
      {ds.length > 1 && (
        <p className="mt-1.5 text-[11.5px] leading-snug text-texto-suave">
          É a <strong>mesma chave</strong> em digests diferentes — <strong>publique só um</strong>.
          O <strong>SHA-256</strong> é o recomendado e o que o registro.br aceita; o SHA-384 é
          opcional (alguns registradores não aceitam).
        </p>
      )}
    </div>
  );
}
